import { StreamingMarkdown } from '../markdown-text/StreamingMarkdown.tsx';
import { Bubble } from '#plugin-chat/components/bubble/Bubble.tsx';
import type { BubbleKind } from '#plugin-chat/components/bubble/bubble-types.ts';

export interface AssistantBubbleProps {
  /** Runtime status of the message, used to determine if streaming is active */
  status?: { type: string };
  /** Message content type (e.g., 'text', 'tool-call') */
  type?: string;
  /** The message text content */
  text?: string;
  /** Visual variant of the bubble */
  kind?: BubbleKind;
}

/** Renders an assistant message bubble with loading state for streaming responses. */
export function AssistantBubble({ text, kind }: AssistantBubbleProps) {
  return (
    <Bubble kind={kind} role="assistant">
      <StreamingMarkdown text={text ?? ''} />
    </Bubble>
  );
}
